import { render, staticRenderFns } from "./ZonaForm.vue?vue&type=template&id=6bb06fce&scoped=true"
import script from "./ZonaForm.vue?vue&type=script&lang=js"
export * from "./ZonaForm.vue?vue&type=script&lang=js"
import style0 from "./ZonaForm.vue?vue&type=style&index=0&id=6bb06fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb06fce",
  null
  
)

export default component.exports